import { createComponent } from '@helpers/admin';
import PricingSectionComponent from '@template/blocks/PricingSection/component';

export const PricingSection = createComponent({
  label: 'Pricing Section',
  component: PricingSectionComponent,
  fields: {
    heading: {
      label: 'Heading',
      type: 'textarea',
    },
    footer: {
      label: 'Footer',
      type: 'textarea',
    },
    countOptions: {
      label: 'Count Options',
      type: 'object',
      objectFields: {
        defaultValue: {
          label: 'Default Count',
          type: 'number',
          default: 2,
        },
        showInput: {
          label: 'Show Number Input',
          type: 'boolean',
          default: true,
        },
        showSlider: {
          label: 'Show Slider',
          type: 'boolean',
          default: true,
        },
      },
    },
  },
});
